export default class UrlConfig {
  public static PATH_BASE_CONTENT_SERVICE = "/api/content/v1"
  public static PATH_BASE_OFFER_SERVICE = "/api/offer/v1"
  public static PATH_BASE_TYPESENSE = "/api/typesense"
}
